var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart-wrapper"},[_c('canvas',{staticClass:"responsive",attrs:{"id":"myChartDay"}})])])
}]

export { render, staticRenderFns }